<div class="fixed top-0 right-0 z-100 bg-[var(--bg-modal)]" [ngClass]="{'w-full h-full flex ': !!modalData}">

    <div class="grow" (click)="closeModal()" (keypress)="{}" tabindex="0"
        [ngClass]="{'pointer-events-none': !allowToClose }"></div>

    <div class=" h-full bg-[var(--background-primary-color)] rounded-l-lg w-full"
        [ngClass]="{'p-4 sm:p-8 sm:pr-4' : modalData, 'sm:w-[42vw]': modalSize === 'compact', 'sm:w-[80vw]': modalSize === 'wide',  'sm:w-[55vw]': modalSize === 'auto'}">
        <ng-container #container></ng-container>
    </div>
</div>